exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.delete-button {\n  cursor: pointer; }\n  .delete-button.danger svg path {\n    fill: #ff4542; }\n  .delete-button .confirm {\n    color: #aaa;\n    margin-left: 10px;\n    font-size: 0.8rem;\n    font-style: italic;\n    animation: fadeIn 0.2s linear; }\n  .delete-button .confirmLink {\n    cursor: pointer;\n    text-decoration: underline; }\n    .delete-button .confirmLink:hover {\n      color: #666; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/ui/DeleteButton/DeleteButton.scss
// module id = 155
// module chunks = 0